export default {
    data: () => ({
        offset: '50%',
        isDragging: false,
        containerInfo: {},
    }),
    imageContainer: null,
    render() {
        return this.$scopedSlots.default({
            offset: this.offset,
            startSliding: this.startSliding,
            stopSliding: this.stopSliding,
            moveSlide: this.moveSlide,
            registerImageContainer: this.registerImageContainer,
        });
    },
    mounted() {
        document.addEventListener('mouseup', this.stopSliding);
        document.addEventListener('touchend', this.stopSliding);
        document.addEventListener('touchmove', this.moveSlide);
        window.addEventListener('resize', this.updateContainerInfo);
    },
    beforeDestroy() {
        document.removeEventListener('mouseup', this.stopSliding);
        document.removeEventListener('touchend', this.stopSliding);
        document.removeEventListener('touchmove', this.moveSlide);
        window.removeEventListener('resize', this.updateContainerInfo);
    },
    methods: {
        registerImageContainer({ el }) {
            this.$options.imageContainer = el;
            this.updateContainerInfo();
        },
        updateContainerInfo() {
            const { imageContainer } = this.$options;
            this.containerInfo = imageContainer.getBoundingClientRect();
        },
        startSliding(event) {
            this.sliding = true;
            this.moveSlide(event);
        },
        moveSlide(event) {
            if (this.sliding) {
                const position = (event.touches ? event.touches[0].pageX : event.pageX) - this.containerInfo.left;

                const percent = (position / this.containerInfo.width) * 100;

                // Don't update offset if we're within 3% of edge
                if (percent > 97 || percent < 2) return;

                this.offset = `${percent}%`;
            }
        },
        stopSliding() {
            this.sliding = false;
        },
    },
};
